import UserField from "kinnect-front/User/UserField";
import { FetchesData } from "kinnect-mixins";
import { KForm, KTextField } from "kinnect-general";
import { User } from "kinnect-models";

export default KForm.extend( {
	name: "KSalesmanForm",

	mixins: [ FetchesData ],

	props: {
		redirect: {
			...KForm.options.props.redirect,
			default: () => [ "back", { name: "salesmen" } ]
		},

		salesman: Object
	},

	data: () => ( {
		formFields: { idUser: null },
		users: []
	} ),

	methods: {
		async fetchUsers() {
			if ( !this.readonly ) {
				this.users = await User.custom( "users/exclude-salesmen" ).get();
			}
		},

		async fetch() {
			await this.fetchUsers();
		}
	},

	watch: {
		salesman: {
			handler( salesman ) {
				if ( salesman ) {
					Object.keys( this.formFields ).forEach( key => {
						if ( salesman.hasOwnProperty( key ) ) {
							this.formFields[key] = salesman[key];
						}
					} );
				}
			},
			immediate: true
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: "sales/salesmen",
				data: this.formFields,
				method: "post"
			}}
			on={this.$listeners}
		>
			{this.readonly
				? <KTextField
					disabled
					label="User*"
					prependIcon="person"
					value={this.salesman ? this.salesman.user.name : null}
				></KTextField>
				: <UserField
					items={this.users}
					label="User*"
					loading={this.$wait.is( "get users" )}
					required
					vModel={this.formFields.idUser}
					validationName="user"
					validationRules="required"
				></UserField>
			}
		</KForm>;
	}
} );
